import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const ProductCodesContainer: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    display: 'flex',
    flexDirection: 'column',
    color: siteVariables.colors.grey['300'],
    fontSize: pxToRem(16),
    lineHeight: pxToRem(30),
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    letterSpacing: pxToRem(0.06),
    maxWidth: pxToRem(678),
    paddingTop: pxToRem(23),
    '& span': {
        display: 'inline-block',
        wordBreak: 'break-all',
        cursor: 'inherit',

        '&:first-child': {
            textTransform: 'uppercase',
            paddingBottom: pxToRem(1),
        },
    },

    [screen.max.tablet]: {
        paddingBottom: pxToRem(12),
        fontSize: siteVariables.fontSizes.caption04,
        lineHeight: 1.25,
        '& span:first-child': {
            textTransform: 'none',
        },
        '& span': {
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
        },
    },
});
